<template>
  <div class="container">
    <div class="item-container">
      <div class="menu-content">
        <menu-list name="配置备份Wi-Fi" subName @click.native="goPage('hot')"></menu-list>
        <!-- <menu-list name="下载整月日历" subName="" @click.native="show = true"></menu-list> -->
        <!-- <menu-list name="下载整月日历" subName="" @click.native="goPage('down')"></menu-list> -->
      </div>
    </div>
    <!-- <van-cell title="选择单个日期" :value="date" @click="show = true" /> -->
    <!-- <van-calendar
      style="height:340px"
      v-model="show"
      :show-mark="false"
      :round="false"
      :show-confirm="false"
      color="#000000"
      @confirm="onConfirm"
    />-->
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
// import { Calendar } from "vant";
// import { Cell } from "vant";
export default {
  data () {
    return {
      date: '',
      show: false
    }
  },
  components: {
    NavBar,
    MenuList
    // [Calendar.name]: Calendar,
    // [Cell.name]: Cell,
  },
  methods: {
    // formatDate(date) {
    //   return `${date.getMonth() + 1}/${date.getDate()}`;
    // },
    // onConfirm(date) {
    //   this.show = false;
    //   this.date = this.formatDate(date);
    // },
    leftClick () {
      this.$router.push({path: '/Setting'})
    },
    goPage (e) {
      if (e === 'hot') {
        this.$router.push({ path: '/hotSetting' })
      } else if (e === 'down') {
        this.$router.push({ path: '/BatchDownload' })
      }
    }
  },
  created () {
    Common.setTitle('更多设置')
  }
}
</script>
<style lang="stylus" scoped>
.item-container {
  height: calc(100% - 56px);
  overflow: auto;

  .menu-content {
    border-top: 1px solid #ededed;
    padding: 0 16px;
    background: #ffffff;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/MoreSetting/MoreSetting.vue